import React from 'react';
import { Provider } from 'react-redux';
import { store } from "./initStore";
import Routes from "./Router";
import { Component } from 'react';
// import { fcm_messages } from "./init-fcm";
import { isBrowser, isElectron, isIOS, isIOS13, isAndroid } from 'react-device-detect';
import { androidNotifFunc, iosNotifFunc, webNotifFunc} from './common';

class App extends Component {
    // componentDidMount = async () => {
    //     if (fcm_messages !== null) {
    //         if (isAndroid) {
    //             androidNotifFunc(fcm_messages);
    //         } else if (isIOS || isIOS13) {
    //             iosNotifFunc(fcm_messages);
    //         } else if (isElectron || isBrowser ) {
    //             webNotifFunc(fcm_messages)
    //         }
    //     }
        
    // }

    render = () => {
        return (
            <Provider store={store}>
                <Routes />
            </Provider>
        )
    }
}

export default App;
